import { fromJS, List, Map } from 'immutable';
import get from 'lodash/get';

import * as VerificationConstants from './constants';
import * as D from './deps';

const INITIAL_STATE = Map({
  [VerificationConstants.ReducerKeys.DISCOUNT_ORG_SEARCH_RESULTS]: List(),
  [VerificationConstants.ReducerKeys.DISCOUNT_VERIFICATION_ERROR_TYPE]: '',
  [VerificationConstants.ReducerKeys.DISCOUNT_VERIFICATION_ERROR_MESSAGE]: '',
  [VerificationConstants.ReducerKeys.DISCOUNT_VERIFICATION_INFO_IS_LOADED]: false,
  [VerificationConstants.ReducerKeys.DISCOUNT_VERIFICATION_INFO]: Map(),
});

export default D.createReducer(INITIAL_STATE, {
  [D.Constants.Api.ApiActions.GET_DISCOUNT_VERIFICATION_INFO_SUCCESS]:
    onDiscountVerificationApiSuccess,
  [D.Constants.Api.ApiActions.SUBMIT_DISCOUNT_VERIFICATION_SUCCESS]:
    onDiscountVerificationApiSuccess,
  [D.Constants.Api.ApiActions.SUBMIT_DISCOUNT_VERIFICATION_FAIL]: onDiscountVerificationApiFail,
  [D.Constants.Api.ApiActions.DISCOUNT_ORG_SEARCH_AUTOCOMPLETE_SUCCESS]:
    onDiscountSearchAutoCompleteApiSuccess,
  [VerificationConstants.Actions.CLEAR_DISCOUNT_VERIFICATION_INFO]: onClearDiscountVerificationInfo,
  [VerificationConstants.Actions.RESET_DISCOUNT_VERIFICATION_ERROR]: resetDiscountVerificationError,
});

function onDiscountVerificationApiSuccess(state, action) {
  const discountVerificationInfo = Array.isArray(action.response)
    ? fromJS(action.response[0])
    : action.response;
  return state.merge({
    [VerificationConstants.ReducerKeys.DISCOUNT_VERIFICATION_INFO_IS_LOADED]: true,
    [VerificationConstants.ReducerKeys.DISCOUNT_VERIFICATION_INFO]:
      discountVerificationInfo || Map(),
  });
}

function onDiscountVerificationApiFail(state, action) {
  const errorType = get(action, 'error.errorType') || 'GENERIC_FAILURE';
  const errorMessage = get(action, 'error.errorMessage') || '';
  return state.merge({
    [VerificationConstants.ReducerKeys.DISCOUNT_VERIFICATION_ERROR_TYPE]: errorType,
    [VerificationConstants.ReducerKeys.DISCOUNT_VERIFICATION_ERROR_MESSAGE]: errorMessage,
  });
}

function onDiscountSearchAutoCompleteApiSuccess(state, action) {
  return state.set(
    VerificationConstants.ReducerKeys.DISCOUNT_ORG_SEARCH_RESULTS,
    action.response ? fromJS(action.response) : List(),
  );
}

function onClearDiscountVerificationInfo(state) {
  return state.merge({
    [VerificationConstants.ReducerKeys.DISCOUNT_VERIFICATION_INFO_IS_LOADED]: INITIAL_STATE.get(
      VerificationConstants.ReducerKeys.DISCOUNT_VERIFICATION_INFO_IS_LOADED,
    ),
    [VerificationConstants.ReducerKeys.DISCOUNT_VERIFICATION_INFO]: INITIAL_STATE.get(
      VerificationConstants.ReducerKeys.DISCOUNT_VERIFICATION_INFO,
    ),
  });
}

function resetDiscountVerificationError(state) {
  return state.merge({
    [VerificationConstants.ReducerKeys.DISCOUNT_VERIFICATION_ERROR_TYPE]: INITIAL_STATE.get(
      VerificationConstants.ReducerKeys.DISCOUNT_VERIFICATION_ERROR_TYPE,
    ),
    [VerificationConstants.ReducerKeys.DISCOUNT_VERIFICATION_ERROR_MESSAGE]: INITIAL_STATE.get(
      VerificationConstants.ReducerKeys.DISCOUNT_VERIFICATION_ERROR_MESSAGE,
    ),
  });
}
